import src from "IMAGE";
export default { src, width: 25, height: 30, blurWidth: 0, blurHeight: 0};
